import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { records as userRecords } from '@saucelabs/sl-module-user';
import { Button } from '@saucelabs/sl-component-buttons';
import { actions as authActions } from '@saucelabs/sl-container-authentication';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import {
  trackEvent,
  EVENTS,
  SUBJECTS,
  VERIFICATION_PRODUCT_AREA,
  VERIFICATION_PRODUCT_SUBAREA,
} from '../tracking';
import EnvelopeRebrandImage from '../images/envelope-rebrand.svg';
import styles from './EmailVerificationContainer.styles';

const EmailVerificationContainer = ({ user, resendEmail, onEmailSend }) => {
  const [sendEmailTimeout, setSendEmailTimeout] = useState(undefined);

  useEffect(() => {
    trackEvent(EVENTS.PAGE_VIEWED, {
      subject_name: SUBJECTS.ACCOUNT_VERIFICATION,
      product_area: VERIFICATION_PRODUCT_AREA,
      product_sub_area: VERIFICATION_PRODUCT_SUBAREA,
      domain: window.location.origin,
      page: window.location.pathname,
    });
  }, []);

  const history = useHistory();
  useEffect(() => {
    if (user && user.canUseSauceLabs()) {
      history.push('/');
    }
  }, [user]);

  return (
    <main className={styles.main}>
      <EnvelopeRebrandImage />
      <h1>Verify your email to continue using Sauce.</h1>
      <div className={styles.notice}>
        <p>
          We&apos;ve sent an email to
          {' '}
          {user && user.email}
          {' '}
          with a verification link.
        </p>
        <p className={styles['resend-container']}>
          If you don’t see it, check your spam folder for an email from
          noreply@saucelabs.com or&nbsp;
          <Button
            category="link"
            className={classNames(styles.resend, styles['help-link'])}
            onClick={() => {
              if (sendEmailTimeout) return;
              const timeout = setTimeout(() => setSendEmailTimeout(), 5000);
              setSendEmailTimeout(timeout);

              resendEmail();
              onEmailSend();
              trackEvent(EVENTS.OBJECT_CLICKED, {
                subject_name: SUBJECTS.RESEND_EMAIL,
                product_area: VERIFICATION_PRODUCT_AREA,
                product_sub_area: VERIFICATION_PRODUCT_SUBAREA,
                domain: window.location.origin,
                page: window.location.pathname,
              });
            }}
            size="sm"
          >
            resend the email
          </Button>
          .
        </p>
        <p>
          If all else fails, drop us a line at
          {' '}
          <a
            className="text-green-600"
            href="mailto: help@saucelabs.com"
          >
            help@saucelabs.com
          </a>
          {''}
          .
        </p>
      </div>
    </main>
  );
};

EmailVerificationContainer.propTypes = {
  onEmailSend: PropTypes.func.isRequired,
  resendEmail: PropTypes.func.isRequired,
  user: ImmutablePropTypes.recordOf(userRecords.UserRecord).isRequired,
};

const mapStateToProps = ({ user }) => ({
  user,
});

const mapDispatchToProps = (dispatch) => ({
  onEmailSend: () => dispatch(notificationActions.notifyInfo('Email sent!', undefined, undefined, undefined, true)),
  resendEmail: () => dispatch(authActions.resendEmail()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmailVerificationContainer);
export { EmailVerificationContainer };
